import React, { useState } from "react";
import "./WorkRequestDetails.css";
import HeaderNav from "../../../shared/components/HeaderNav";
import profileIcon from '../../../shared/assets/icons/profile.png';
import { IoArrowUndoOutline } from "react-icons/io5";
import { useNavigate } from 'react-router-dom';
import StepperComponent from "../../../components/StepperComponent";
const WorkOrderDetails = () => {
  const navigate = useNavigate();

  // Dynamic stepper data
  const [steps, setSteps] = useState([
    {
      id: 1,
      title: "Reported",
      status: "completed",
      meta: {
        date: "01/02/2026",
        time: "11:30 AM",
        extra: "Some unwanted sounds while switched on"
      }
    },
    {
      id: 2,
      title: "Assigned",
      status: "completed",
      meta: {
        date: "02/02/2026",
        time: "12:30 PM",
        extra: "Assigned to Sanjeev Kumar"
      }
    },
    {
      id: 3,
      title: "Evaluated",
      status: "pending",
      meta: null
    },
    {
      id: 4,
      title: "Estimated",
      status: "pending",
      meta: null
    },
    {
      id: 5,
      title: "Approved",
      status: "pending",
      meta: null
    },
    {
      id: 6,
      title: "Work Started",
      status: "pending",
      meta: null
    },
    {
      id: 7,
      title: "Completed",
      status: "pending",
      meta: null
    },
    {
      id: 8,
      title: "Closed",
      status: "pending",
      meta: null
    }
  ]);

  // You can set current step index based on your logic
  const currentStepIndex = 2; // 0-based index (step 3 is current)

  return (
    <div className="maintenance-request">
      <HeaderNav profileIcon={profileIcon} />
      {/* Header Section */}
      <div className="second-header">
        <button className="back-button">
          <IoArrowUndoOutline color="black" size={25} alt="Back" onClick={() => navigate('/tasklist')} />
        </button>
        <h2 className="page-title">Maintenance Details</h2>
      </div>
     {/* Mobile Header */}
         <header className="mobile-header">
           <div className="header-left">
              <IoArrowUndoOutline color="black" size={25} alt="Back" onClick={() => navigate('/tasklist')} />
           </div>
           <h1 className="app-title">Maintenance Details</h1>
         </header>
      
      <div className="workorder-container">
        {/* Main product card */}
        <div className="product-card">
          <div className="product-title-row">
            <span className="product-name">Air Conditioner | Voltas</span>
            <span className="verified-badge">Verified</span>
          </div>

          <div className="status-warranty-row">
            <span className="status ongoing">Ongoing</span>
            <span className="warranty">VOL87 | Under Warranty</span>
            <span className="warranty">
              <strong>Request ID:</strong> 578241
            </span>
          </div>

          <div className="issue-description">
            Some unwanted sounds while switched on. Drop of water while swing
          </div>

          <div className="date-price-row">
            <div className="reported-date">
              <span className="label">Reported On</span>
              <span className="value">Feb '02 2026</span>
            </div>
            <div className="total-price">
              <span className="label">Total</span>
              <span className="value">₹ 2500</span>
            </div>
          </div>
        </div>

        {/* service status header with action links */}
        <div className="service-status-header">
          <h3>Your Service Status</h3>
          <div className="action-links">
            <span>View History</span> <span>|</span> <span>Checklist</span>{" "}
            <span>|</span> <span>Estimation</span> <span>|</span>{" "}
            <span>Invoice</span>
          </div>
        </div>

        {/* Dynamic Stepper */}

      </div>
    </div>
  );
};

export default WorkOrderDetails;